import type { MouseEvent } from 'react';

import ChevronIcon from '~/assets/icons/Chevron';
import CloseIcon from '~/assets/icons/Close';
import SoleIcon from '~/assets/icons/Sole';

import { brandLogos } from '../brandLogos';
import type { MenuItemProps } from '../types';

interface MobileMenuHeaderProps {
  headerBack: (item: MenuItemProps) => void;
  name: string;
  onClose: () => void;
  selectedItem: MenuItemProps | null;
  showBackButton: boolean;
}

export default function MobileMenuHeader({
  name,
  headerBack,
  onClose,
  selectedItem,
  showBackButton
}: MobileMenuHeaderProps) {
  function goBack() {
    if (headerBack && selectedItem) headerBack(selectedItem);
  }

  function closeMenu(event: MouseEvent) {
    event.stopPropagation();
    onClose();
  }

  function goBackFromButton(event: MouseEvent) {
    event.stopPropagation();
    goBack();
  }

  return (
    <div
      role="presentation"
      className="sticky top-0 z-10 mb-3 h-[60px] bg-white text-[16px] font-bold leading-[26px]"
      onClick={goBack}
    >
      <div className="absolute left-0 top-0 z-[1] flex h-full items-center gap-4 pb-[6px]">
        {!showBackButton && (
          <button
            type="button"
            aria-label="Close menu"
            onClick={closeMenu}
            className="cursor-pointer"
          >
            <CloseIcon width="12" height="12" stroke="black" />
          </button>
        )}
        {showBackButton && (
          <button
            type="button"
            aria-label="Back"
            onClick={goBackFromButton}
            className="inline-block rotate-90 cursor-pointer"
          >
            <ChevronIcon width="14" height="14" stroke="#333333" />
          </button>
        )}
      </div>
      <div className="flex h-full items-center justify-center">
        {!selectedItem || !name ? (
          <div className="mt-3">
            <SoleIcon width="50" height="50" colour="#000000" />
          </div>
        ) : (
          <>
            {selectedItem.type === 'brand' ? (
              <div className="mt-3">
                <img
                  className="h-[50px]"
                  loading="lazy"
                  alt={selectedItem.name}
                  src={brandLogos[selectedItem.icon]}
                />
              </div>
            ) : (
              selectedItem.displayName || selectedItem.name
            )}
          </>
        )}
      </div>
    </div>
  );
}
